// extracted by mini-css-extract-plugin
module.exports = {"focus":"CompaniesAddContent_focus__2xBJM","input":"CompaniesAddContent_input__jOb2f","domain":"CompaniesAddContent_domain__2Ab18","relative":"CompaniesAddContent_relative__3VUcP"};